import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})

export class AdmintoolService {  
  constructor(private httpClient: HttpClient) {}

  getDashboard() {
    return this.httpClient.get(`${environment.apiBaseUrl}AdminTool`);
   }
}